import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Allpayment = () => {
  let [data, setData] = useState();

  let [datae, setDatae] = useState();

  let [indexs, setIndex] = useState(0);
  let [count, setCount] = useState();

  let [pikk, setPikk] = useState(false);

  let [selas, setSelas] = useState();
  let [sel, setSel] = useState("All");

  let [charge, setCharge] = useState();

  let [datadd, setDatadd] = useState();
  let [charggges, setChsrggess] = useState();

  let [ff, setFF] = useState(false);

  let [sms, setSms] = useState([]);

  let [pg_res, Setpg_res] = useState();

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState("");

  useEffect(() => {
    Start(); 
  }, []);
 

  
 

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0 , value };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/allpayment",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setFF(Jsson.rent)
            setCount(Jsson.count);
            
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };
 

  function convertDateString(dateString) {
    const now = new Date(dateString);

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
 
 

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }} >
          {ff === false ? (
            <>
             <div className="row">
              <div style={{ padding: 10 }}>
                <div className="row">
                  <div className="col-3">
                    <input
                      onChange={(e) => {
                        inputvalue(e.target.value);
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Enter Order Id"
                    />
                  </div>
                  <div className="col-3">
                    <button
                      onClick={() => {
                        User();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                      User {"  "} 
                    </th>
                    <th scope="col">Amount</th>
                    <th scope="col">Details</th>
                    <th scope="col">Charge</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((tt, index) => {
                    let ccj = tt.charge ? JSON.parse(tt?.charge) : {};

                    console.log(tt, "tttttttt");

                    let one = 0;
                    let two = 0;
                    let three = 0;
                    let fouer = 0;

                    tt.pay.map((fff, dataff) => {
                      if (fff.payment_status_msg === "Failed") {
                        one = one + 1;
                      } else if (fff.payment_status_msg === "Processing") {
                        two = two + 1;
                      } else if (fff.payment_status_msg === "Success") {
                        three = three + 1;
                      } else if (fff.payment_status_msg === "Refund") {
                        fouer = fouer + 1;
                      }
                    });

                    return (
                      <tr
                        style={{ cursor: "pointer" }}
                       
                      >
                        <th scope="row">
                          {" "}
                          {indexs}
                          {index + 1}
                        </th>
                        <td>
                          <div>
                          <p style={{ color : 'Red' , fontSize : 16 , fontWeight : "700" }} >Type : { tt?.category }</p>
                            <p>{tt?.user?.name}</p>
                            <p>{tt?.user?.phoneno}</p>
                            <p>{tt?.user?.email}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p>Amount : {tt?.amount}</p>
                            <p>Con Fee {tt?.confess}</p>
                            <p>Gst : {tt?.gst}</p>
                            <p>Total Amount : {tt?.total}</p>
                          </div>
                        </td>
                        <td>
                          <div>  
                            <p>Payment id : {tt?.pg_transactionId}</p>
                            <p>Xopay id :{tt?.xopayid}</p>
                            <p
                              style={{
                                color:
                                  tt?.payment_status_msg === "Processing" ||
                                  tt?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : tt?.payment_status_msg === "Failed"
                                    ? "red"
                                    : "green",
                                fontWeight: "700",
                              }}
                            >
                              {tt?.payment_status_msg}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div> 
                            <p>date : {convertDateString(tt?.createdAt)}</p>

                            {/* <button
                              onClick={() => {
                                navigate("/rentdetail", { state: tt });
                              }}
                            >
                              View User
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

           
            </div>
            </>
          ) : (
            <div className="row">
              <div style={{ padding: 10 }}>
                <div className="row">
                  <div className="col-3">
                    <input
                      onChange={(e) => {
                        inputvalue(e.target.value);
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Enter Order Id"
                    />
                  </div>
                  <div className="col-3">
                    <button
                      onClick={() => {
                        User();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                      User {"  "} 
                    </th>
                    <th scope="col">Amount</th>
                    <th scope="col">Details</th>
                    <th scope="col">Charge</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((tt, index) => {
                    let ccj = tt.charge ? JSON.parse(tt?.charge) : {};

                    console.log(tt, "tttttttt");

                    let one = 0;
                    let two = 0;
                    let three = 0;
                    let fouer = 0;

                    tt.pay.map((fff, dataff) => {
                      if (fff.payment_status_msg === "Failed") {
                        one = one + 1;
                      } else if (fff.payment_status_msg === "Processing") {
                        two = two + 1;
                      } else if (fff.payment_status_msg === "Success") {
                        three = three + 1;
                      } else if (fff.payment_status_msg === "Refund") {
                        fouer = fouer + 1;
                      }
                    });

                    return (
                      <tr
                        style={{ cursor: "pointer" }}
                        // onClick={() => {
                          

                        //   console.log(tt, "kkkkkkkkk");

                        //   setPikk(true);
                        //   setFF(tt);
                        //   setCharge(tt);
                        //   setDatae(tt?.marchantid[0]);
                        //   if (tt?.charge != undefined) {
                        //     setChsrggess(JSON.parse(tt?.charge));
                        //   }
                        //   if (tt?.pg_res != undefined) {
                        //     Setpg_res(JSON.parse(tt?.pg_res));
                        //   }

                        //   if (tt?.sms?.length === 0 || tt?.sms === undefined) {
                        //     setSms([]);
                        //   } else {
                        //     setSms(JSON.parse(tt?.sms));
                        //   }

                        //   tt.pay.map((fff, dataff) => {
                        //     console.log(
                        //       fff.payment_status_msg,
                        //       "payment_status_msgpayment_status_msgpayment_status_msg"
                        //     );
                        //     if (fff.payment_status_msg === "Failed") {
                        //       let jh = 0;
                        //       jh = jh + 1;
                        //       setones(jh);
                        //     } else if (
                        //       fff.payment_status_msg === "Processing"
                        //     ) {
                        //       let jh = 0;
                        //       jh = jh + 1;
                        //       settwos(jh);
                        //     } else if (fff.payment_status_msg === "Success") {
                        //       let jh = 0;
                        //       jh = jh + 1;
                        //       setthrees(threes + 1);
                        //     } else if (fff.payment_status_msg === "Refund") {
                        //       let jh = 0;
                        //       jh = jh + 1;
                        //       setfouers(jh);
                        //     }
                        //   });

                        //   // togglePanel(tt);
                        // }}
                      >
                        <th scope="row">
                          {" "}
                          {indexs}
                          {index + 1}
                        </th>
                        <td>
                          <div>
                          <p style={{ color : 'Red' , fontSize : 16 , fontWeight : "700" }} >{tt?.category}</p>
                            <p>{tt?.user?.name}</p>
                            <p>{tt?.user?.phoneno}</p>
                            <p>{tt?.user?.email}</p>

                            <div className="row">
                              <div className="col-6">Fail : {one}</div>
                              <div className="col-6">Success : {three}</div>
                            </div>
                            <div className="row">
                              <div className="col-6">Process : {two}</div>
                              <div className="col-6">Refund : {fouer}</div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p>Amount : {tt?.amount}</p>
                            <p>Con Fee {tt?.co_fess}</p>
                            <p>Gst : {tt?.gst}</p>
                            <p>Total Amount : {tt?.totalamount}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p>Payment method : {tt?.paymethod}</p>
                            <p>Payment Status :{tt?.payment_status}</p>
                            <p>Payment id : {tt?.pg_transactionId}</p>
                            <p>Xopay id :{tt?.xopay_id}</p>
                            <p
                              style={{
                                color:
                                  tt?.payment_status_msg === "Processing" ||
                                  tt?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : tt?.payment_status_msg === "Failed"
                                    ? "red"
                                    : "green",
                                fontWeight: "700",
                              }}
                            >
                              {tt?.payment_status_msg}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p style={{ color: "red", fontWeight: "700" }}>
                              Method : {ccj?.title}
                            </p>
                            <p>Payment Charge :{ccj?.fee}</p>
                            <p>date : {convertDateString(tt?.createdAt)}</p>

                            {/* <button
                              onClick={() => {
                                navigate("/rentdetail", { state: tt });
                              }}
                            >
                              View User
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

           
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Allpayment;
